/** Ghana's country code. Local numbers start with 0 in place of it. */
const COUNTRY_CODE = '233';

/**
 * One form for a phone number, so the same SIM matches however it was typed:
 * "0274172817", "+233 27 417 2817" and "233274172817" all become
 * "233274172817". Returns null when there are no digits.
 */
export function normaliseMsisdn(value: string | null | undefined): string | null {
  const digits = (value ?? '').replace(/\D/g, '');
  if (!digits) return null;
  if (digits.startsWith('00')) return digits.slice(2);
  if (digits.startsWith('0')) return COUNTRY_CODE + digits.slice(1);
  // A local number typed without its leading 0.
  if (digits.length === 9) return COUNTRY_CODE + digits;
  return digits;
}
